import React from "react";
import { useMsal } from "@azure/msal-react";
import { LinkButton } from "../LinkButton";

export const SignOutButton = () => {
  const { instance } = useMsal();
  
  return (
    <LinkButton onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: "/" })}>
      Log Out
    </LinkButton>
  );
};